query positionOverlayAttributeKeys {
  positionOverlayAttributeKeys {
    key
    label
    kind
    powerOrAdminOnly
  }
}
